import { useEffect } from "react";
import { useFileNavigator } from "context/FileNavigator";
import { getButtonsNoYes, getButtonsNoYesDanger } from "context/helpers/helperModalContext";
import { useModal } from "context/ModalContext";
import SolarTrashBinMinimalisticLinear from "components/icons/SolarTrashBinMinimalisticLinear";
import { useTranslation } from "react-i18next";
import * as apiFN from "api/apiFileNavigator";
import { useToast } from "context/ToastContext";
import SvgTrash from "components/svg/SvgTrash";


const DeleteFile = ({fileData, showDelDlg, setShowDelDlg}) => { 
     
    const { t } = useTranslation(['FileNavigator']);
    const { showDlg } = useModal();
    const { showToast } = useToast();
    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();
 
     
    // Парамтери діалогу для видалення файлів та папок
    const paramsDelDlg = {
        buttons : [...getButtonsNoYesDanger(t)], 
        type    : 'confirm',
        text    : (
                <h4 className="d-flex text-danger">
                <SvgTrash className="text-danger"/> 
                <span className="ps-2">{t('confirmDelete')}</span></h4>)
    } 
  
    // Функція кнопки видалення 
    paramsDelDlg.buttons[1].handleClick = () => { 
        showDlg(false);
        handleDeleteFiles();
    }

    // Функція видалення файлів
    const handleDeleteFiles =  async () => {
        dispatchFN({type:'SET_DATA_FN', payload:null});
        const aFiles = (stateFN.selectedFiles?.length>0) 
            ? stateFN.selectedFiles
            : [`${fileData?.filePath||''}/${fileData?.fileName||''}`];

        // Запит на видалення файлів
        const resDelete = await apiFN.deleteFiles(aFiles);
        dispatchFN({type:'TOGGLE_SELECTED', payload:null})
        if (resDelete) showToast(t('messDeletedSuccess'), 'success')
            else showToast(t('common:messError'), 'danger');

        fetchDataFN(true);

    }

    useEffect(()=>{
        if (showDelDlg) {
            showDlg(paramsDelDlg);
            setShowDelDlg(false)
        }
    }, [showDelDlg]) 

    return <></>; 
}

export default DeleteFile;